import PropTypes from 'prop-types';

const propTypes = {
  path: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool,
};

const defaultProps = {
  isAuthenticated: false,
};

export { propTypes, defaultProps };
